<template>
  <div class="ibox">
    <div class="ibox-title">
      <h5>{{title}}</h5>
      <div class="ibox-tools">
        <slot name="tools" />
      </div>
    </div>
    <div class="ibox-content wizard-box-content">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: "WizardBox",
  props: {
    title: String
  }
};
</script>